<template>
  <div>
    <section class="hero is-white">
      <div class="hero-body">
        <div class="container">
          <div class="is-size-3 has-text-centered">Start Using Map Our Borders</div>
          <div class="is-size-5 has-text-centered">Sign up is free and lets you add your own places and comments!</div>
        </div>
      </div>
    </section>
    <section id="successWrap">
      <div class="is-size-5 has-text-centered">New user account for {{username}} successfully added!</div>
      <br>
      <div class="field is-grouped is-grouped-centered">
        <div class="control">
          <button class="button is-primary" @click="proceed()">Start Mapping</button>
        </div>
      </div>
    </section>
    <section id="formWrap">
    	<div id="form" class="box container has-text-centered animated bounceInDown form">
        <div class='field'>
  	      <b-field label="Username">
            <b-input id="focus"
              type="text"
              placeholder="JaneDoe"
              v-on:keyup.native.enter="submit()"
              v-model="username"
              icon-pack="fas"
              icon="user">
            </b-input>
          </b-field>
          <p id="noName" class="help is-danger">Please enter a username</p>
        </div>
        <div class='field'>
          <b-field label="Password">
            <b-input type="password"
              placeholder="Password"
              v-on:keyup.native.enter="submit()"
              v-model="password"
              icon-pack="fas"
              icon="key"
              password-reveal>
            </b-input>
          </b-field>
          <p id="noPass" class="help is-danger">Please enter a valid password</p>
        </div>
        <div class='field'>
          <b-field label="Confirm Password">
            <b-input type="password"
              placeholder="Confirm Password"
              v-on:keyup.native.enter="submit()"
              v-model="confirmPass"
              icon-pack="fas"
              icon="key"
              password-reveal>
            </b-input>
          </b-field>
          <p id="noPassConfirm" class="help is-danger">Your passwords do not match</p>
        </div>
        <div class='field'>
          <b-field label="Email">
            <b-input type="email"
              placeholder="email@email.com"
              v-on:keyup.native.enter="submit()"
              v-model="email"
              icon-pack="fas"
              icon="envelope">
            </b-input>
          </b-field>
          <p id="noEmail" class="help is-danger">Please enter a valid email address</p>
        </div>
	      <div class="field is-grouped is-grouped-centered">
	        <div class="control">
	          <button class="button is-primary" @click="submit()">Sign Up!</button>
	        </div>
	      </div>
        <p id="failText" class="help is-danger">Registration failed</p>
	     </div>
    </section>
    <router-view />
  </div>
</template>
<script>
import $ from 'jquery';
import router from "../router"
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
export default {
  name: 'signUpForm',
  data() {
    return {
      username: "",
      hasName: false,
      password: "",
      confirmPass: "",
      hasPass: false,
      hasConfirm: false,
      email: "",
      hasEmail: false,
      userData: {}
    }
  },
  computed: {
    API_URL() {
      return this.$store.state.API_URL
    }
  },
  mounted() {
    document.getElementById('focus').focus()
    new SimpleBar(document.getElementById('form'));
  },
  methods: {
    // BROKEN!!!
    // doesn't load protect map after successful signup. 
    // pushes to /protected but nothing happens
    // add confirm password
    submit: function() {
      let $form = new SimpleBar(document.getElementById('form'));
      $('#failText').hide()
      if(this.username == "") {
        $('#noName').show()
      } else {
        this.hasUser = true;
        $('#noName').hide()
      }
      if(this.password == "") {
        $('#noPass').show()
      } else {
        this.hasPass = true;
        $('#noPass').hide()
      }
      if(this.confirmPass == "") {
        $('#noPassConfirm').show()
      } else if(this.confirmPass != this.password){
        $('#noPassConfirm').show()
      } else {
        this.hasConfirm = true;
        $('#noPassConfirm').hide()
      }
      if(this.email == "") {
        $('#noEmail').show()
      } else {
        this.hasEmail = true;
        $('#noEmail').hide()
      }
      if(this.hasUser && this.hasPass && this.hasEmail) {
        $.post(this.API_URL + "/mob/signup", { username: this.username, pwd: this.password, email: this.email })
          .done(data => {
            if(data.id) {
              this.userData = data;
              $('#formWrap').hide();
              $('#successWrap').show();
            } else if(data.badName) {
              $('#failText').html('Registration failed. Username ' + this.username + ' is not available.').show();
            } else if(data.badEmail) {
              $('#failText').html('Registration failed. Email ' + this.email + ' already in use.').show();
            } else {
              $('#failText').html('Registration failed.').show();
            }
          });
      }
      $form.recalculate();
    },
    proceed: function() {
      this.$store.commit('saveUserObj', this.userData);
      router.push("/user/" + this.username);
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hero {
  z-index: 1 !important;
}

.form {
  width: 30%;
  margin-bottom: 100px;
  max-height: 85%;
  height: auto;
}

.hero {
	top: 52px;
	position: fixed;
	width: 100%;
	z-index: 999;
}
#formWrap, #successWrap {
	margin-top: 225px;
  padding-top: 2px;
  position:absolute;
  height: calc(100% - 245px);
  width: 100%;
}
#successWrap {
  display: none;
}
#noName, #noPass, #noEmail, #failText, #noPassConfirm {
  display: none;
}
</style>